export default "__VITE_ASSET__B27y2JwP__"